import { Box } from '@mui/material';
import React from 'react';
import MedicamentoForm from '../components/medicamentoform';

const MedicamentoUpdate = () => {

    return (
        <div>
            <Box m={2}>
                <MedicamentoForm />
            </Box>
        </div>
    )
}

export default MedicamentoUpdate